import { InlineContractReview } from "components/reviews/InlineContractReview";
import { PartnerName } from "components/reviews/PartnerReview";
import React, { useEffect, useRef, useState } from "react";
import { TourProvider, useTour } from "@reactour/tour";
import {
  getContractsById,
  getSignedContracts,
  searchInspector,
  assignContract,
  getHomeownerContractsById,
  getInspectorContractsById,
  getSubcontractorContractsById,
  getSingleProjectById,
} from "../../../../slices/thunk";
import {
  Card,
  Col,
  Container,
  Form,
  Nav,
  Row,
  Tab,
  Spinner,
  Button,
  Dropdown,
  Table,
  Modal,
  Alert,
} from "react-bootstrap";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useNavigation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import AIContractChatModal from "Common/createContractAIModal";
import CreateChangeOrderModal from "../tabs/createChangeOrder";
import { CallAPIDeletePromise, CallAPIPostPromise } from "Common/commaon";
import { TwoButtonAlert } from "Common/twoButtonAlert";
import { IoTrashOutline } from "react-icons/io5";
import Tutorial from "../Tutorial";
import decodeJwt from "helpers/jwt-token-access/jwtdecode";
import { ArrowRight, CheckCircle2, CreditCard, Download, Eye, FileText, Handshake, Home, LockKeyhole, Mail, MoreHorizontal, Pencil, PlusCircle, Trash2, UserCheck } from "lucide-react";
import { canAccessContractRecord, getContractSignerType, hasContractPermission, isHomeownerContractOwner } from "Common/permissions";
import { PERMISSIONS } from "Common/constants/permissions";
import { Contract } from "components/ActionRequired";
import { ContractDetailDialog } from "components/ContractDetailDialog";
import { toast } from "react-toastify";
import { useBillingAccess } from "components/BillingAccessContext";

export function convertToUSFormat(isoDate: any) {
  const date = new Date(isoDate);
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

interface ContractListProps {
  termsAccepted: boolean; handleStatus: () => void
  setPaymentPageShow:any
}

interface JwtPayload {
  userType: string;
}

const ContractList: React.FC<ContractListProps> = ({termsAccepted,handleStatus,setPaymentPageShow}) => {
  const { state: billingAccess, openPaymentRecovery } = useBillingAccess();
  const isSubscriptionSuspended = billingAccess?.accessLevel === "suspended";
  const token = localStorage.getItem("authUser");
  let decoded: any = "";
  const { t } = useTranslation(); // ✅ React knows to update
 const [changeOrderLoadingStatus,setChangeOrderLoadingStatus] = useState(false)
  const [changeOrderModalStatus,setChangeOrderModalStatus]= useState(false)
  const [selectedContract, setSelectedContract] = useState<Contract | null>(null);
  const [selectedActionType, setSelectedActionType] = useState(null);
  const [selectedSignerType, setSelectedSignerType] = useState<"homeowner" | "contractor">("contractor");
  if (token !== null) {
    decoded = jwtDecode<JwtPayload>(token);
  } else {
    console.error("Token is null");
  }
  const contracts = useSelector((state: any) => state.Contract.contracts);

  const contractors = useSelector(
    (state: any) => state.Proposal.searchHomeowners
  );
  const [alertDetails,setAlertDetails]= useState({
    status: false,
    title: "Warning!",
    message: "You’re about to delete your account forever,",
    icon: IoTrashOutline,
    button1Text: "Keep it",
    button2Text: "Delete",
    button1Style: "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition",
    button2Style: "px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition",
    onButton1Click: () => console.log("Saved "),
    onButton2Click: () => console.log("Deleted "),
  })
const [aiModalStatus,setAIModalStatus]= useState(false)
  const [showContractTypeModal, setShowContractTypeModal] = useState(false);
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [showHomeownerForm, setShowHomeownerForm] = useState<boolean>(false);
  const [homeOwnerId, setHomeOwnerId] = useState<any>("");
  const [newHomeowner, setNewHomeowner] = useState<any>([]);
  const [inspectorData, setInspectorData] = useState<any>(null);
  const [assignInspectorLoading, setAssignInspectorLoading] = useState(false);
  const [assignProjectName, setAssignProjectName] = useState("");
  const [projectIdState, setProjectId] = useState<any>("");
  const [modal_assign_inspector, setModal_assign_inspector] = useState(false);
  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);

  let project: any = null;
  project = useSelector((state: any) => state.Contract.project);

  useEffect(() => {
    document.title = "Tradesmen Admin";
  }, []);

  function tog_assign_inspector(pId: any, projectName?: string) {
    setProjectId(pId);
    setAssignProjectName(projectName || "");
    setModal_assign_inspector(!modal_assign_inspector);
    if (!modal_assign_inspector) {
      setHomeOwnerId("");
      setInspectorData(null);
      setShowHomeownerForm(false);
      dispatch(searchInspector(""));
    }
  }

  useEffect(() => {
    // Function to handle the click event
    const handleClickOutside = (event: MouseEvent) => {
      // Get the modal elements
      const backdropElement = document.getElementById("staticBackdrop");

      // Check if the click is outside the modal
      if (backdropElement && !backdropElement.contains(event.target as Node)) {
        // Close the modals if they are open
        if (modal_assign_inspector) {
          setModal_assign_inspector(false);
        }
      }
    };

    // Attach the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modal_assign_inspector]);
  const fetchData = async () => {
    setLoading(true);
    try {
      if (decoded.userType === "admin") {
        await dispatch(getSignedContracts());
      } else if (decoded.userType === "contractor") {
        await dispatch(getContractsById());
      } else if (decoded.userType === "homeowner") {
        await dispatch(getHomeownerContractsById());
      } else if (decoded.userType === "inspector") {
        await dispatch(getInspectorContractsById());
      } else if (decoded.userType === "subcontractor") {
        await dispatch(getSubcontractorContractsById());
      }
    } catch (error) {
      console.error("Error fetching contracts:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
   

    fetchData();
  }, [dispatch, decoded.userType]);

  const handleSelectedValue = (selectedOption: any) => {
    if (!selectedOption?.value) {
      setHomeOwnerId("");
      setInspectorData(null);
      setShowHomeownerForm(false);
      return;
    }

    setHomeOwnerId(selectedOption.value);
    setInspectorData(selectedOption.inspector || null);
    setShowHomeownerForm(true);
  };

  function searchHomeowners(e: any) {
    dispatch(searchInspector(e));
    // setShowHomeownerForm(true)
  }

  useEffect(() => {
    const newData = contractors.map((item: any) => {
      const fullName = [item.user_first_name, item.user_last_name].filter(Boolean).join(" ");
      return {
        label: `${fullName || item.user_email} ${item.user_email ? `(${item.user_email})` : ""}`,
        value: item.id,
        inspector: item,
      };
    });
    setNewHomeowner(newData);
  }, [contractors]);

  async function handleAssignContract() {
    if (!projectIdState || !homeOwnerId || assignInspectorLoading) {
      return;
    }

    setAssignInspectorLoading(true);
    let projectId = projectIdState;
    let inspectorId = homeOwnerId;
    try {
      await dispatch(assignContract(projectId, inspectorId));
      setModal_assign_inspector(false);
      setNotification({
        status: true,
        message: "Inspector Assigned Successfully",
        variant: "success",
      });
      fetchData();
    } catch (error) {
      setNotification({
        status: true,
        message: "Failed to assign inspector",
        variant: "danger",
      });
    } finally {
      setAssignInspectorLoading(false);
    }
  }
  const handleAlertClick = () => {
    setNotification(null);
  };

  const { setIsOpen,setSteps } = useTour();
  const [currentPage, setCurrentPage] = useState(1);
  const contractsPerPage = 10;
   const navigate = useNavigate()
  const canCreateContract = hasContractPermission(PERMISSIONS.CREATE_CONTRACT);
  const isContractorUser = decoded.userType === "contractor" || decoded.userType === "testContractor";
  const isAdminUser = decoded.userType === "admin";
  const [searchTerm, setSearchTerm] = useState("");
  const [escrowFilter, setEscrowFilter] = useState(isAdminUser ? "escrow" : "all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [sortFilter, setSortFilter] = useState("latest");
  const defaultEscrowFilter = isAdminUser ? "escrow" : "all";
  const filtersAreDefault = !searchTerm && escrowFilter === defaultEscrowFilter && statusFilter === "all" && sortFilter === "latest";
  const draftContracts = contracts.filter((item: any) => item.p_status !== "LIVE").length;
  const liveContracts = contracts.filter((item: any) => item.p_status === "LIVE").length;
  const escrowContracts = contracts.filter((item: any) => Number(item.p_escrow) === 1).length;

  const canManageContractRow = (item: any, permission?: string | string[]) => {
    if (!isContractorUser) {
      return false;
    }

    return canAccessContractRecord(item, permission);
  };

  const openContract = (item: any) => {
    navigate(`/create-contract?tab=Project-Details&id=${item.p_id}`);
  };
  const viewStatus = (item: any) => {
    navigate(`/create-contract?tab=Finish&id=${item.p_id}`);
  };
  const openContractTab = (item: any, action?: string) => {
    setSelectedContract(item.p_id)
    setSelectedSignerType(getContractSignerType(item));
    // navigate(`/create-contract?tab=Homeowner-Contract&id=${item.p_id}${action ? `&action=${action}` : ""}`);
  };

  const getContractUrl = (item: any) =>
    item?.pc_contract_url ||
    item?.contract?.pc_contract_url ||
    item?.contract_url ||
    item?.contract_pdf_url ||
    item?.contract?.contract_url;
  const getContractId = (item: any) =>
    item?.pc_id ||
    item?.contract?.pc_id ||
    item?.contract_id ||
    item?.contract_project_id;
  const getContractorSignature = (item: any) =>
    item?.pc_contractor_signature_url ||
    item?.contract?.pc_contractor_signature_url ||
    item?.contractor_signature_url ||
    item?.contract?.contractor_signature_url;
  const getHomeownerSignature = (item: any) =>
    item?.pc_homeowner_signature_url ||
    item?.contract?.pc_homeowner_signature_url ||
    item?.homeowner_signature_url ||
    item?.contract?.homeowner_signature_url;

  const getContractStatus = (item: any) => {
    const hasContractDocument = Boolean(getContractId(item) || getContractUrl(item));
    const contractorSigned = Boolean(getContractorSignature(item));
    const homeownerSigned = Boolean(getHomeownerSignature(item));

    if (item.p_status === "LIVE") {
      return { label: "Live", className: "badge contract-status-badge contract-status-success" };
    }

    if (!hasContractDocument) {
      return { label: "Draft", className: "badge contract-status-badge contract-status-draft" };
    }

    if (!contractorSigned) {
      return { label: "Awaiting Contractor", className: "badge contract-status-badge contract-status-awaiting" };
    }

    if (!homeownerSigned) {
      return { label: "Awaiting Homeowner", className: "badge contract-status-badge contract-status-info" };
    }

    return { label: "Signed", className: "badge contract-status-badge contract-status-success" };
  };

  const matchesStatusFilter = (item: any) => {
    if (statusFilter === "all") {
      return true;
    }

    const hasContractDocument = Boolean(getContractId(item) || getContractUrl(item));
    const contractorSigned = Boolean(getContractorSignature(item));
    const homeownerSigned = Boolean(getHomeownerSignature(item));

    if (statusFilter === "draft") {
      return item.p_status !== "LIVE";
    }

    if (statusFilter === "live") {
      return item.p_status === "LIVE";
    }

    if (statusFilter === "signed") {
      return hasContractDocument && contractorSigned && homeownerSigned;
    }

    if (statusFilter === "signature-pending") {
      return hasContractDocument && (!contractorSigned || !homeownerSigned);
    }

    if (statusFilter === "document-ready") {
      return hasContractDocument;
    }

    return true;
  };

  const filteredContracts = contracts
    .filter((item: any) => {
      if (escrowFilter === "escrow" && Number(item.p_escrow) !== 1) {
        return false;
      }

      if (escrowFilter === "non-escrow" && Number(item.p_escrow) === 1) {
        return false;
      }

      if (!matchesStatusFilter(item)) {
        return false;
      }

      const searchValue = searchTerm.trim().toLowerCase();
      if (!searchValue) {
        return true;
      }

      const searchableText = [
        item.p_id,
        item.p_name,
        item.homeOwner_first_name,
        item.homeOwner_last_name,
        item.homeOwner_email,
        item.createdBy_first_name,
        item.createdBy_last_name,
        item.createdBy_email,
        item.p_status,
        item.p_city,
        item.p_state,
        item.p_zip,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return searchableText.includes(searchValue);
    })
    .sort((a: any, b: any) => {
      const aTime = new Date(a.p_created_at || 0).getTime();
      const bTime = new Date(b.p_created_at || 0).getTime();
      return sortFilter === "oldest" ? aTime - bTime : bTime - aTime;
    });

  const totalContracts = filteredContracts.length;
  const totalPages = Math.max(1, Math.ceil(totalContracts / contractsPerPage));
  const indexOfLast = currentPage * contractsPerPage;
  const indexOfFirst = indexOfLast - contractsPerPage;
  const currentContracts = filteredContracts.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, escrowFilter, statusFilter, sortFilter]);

  const canSignContract = (item: any) => {
    if (!getContractId(item) && !getContractUrl(item)) {
      return false;
    }

    if (isHomeownerContractOwner(item)) {
      return Boolean(getContractorSignature(item)) && !getHomeownerSignature(item);
    }

    if (isContractorUser) {
      return !getContractorSignature(item);
    }

    return false;
  };

  const sendContract = (item: any) => {
    setChangeOrderLoadingStatus(item.p_id);
    CallAPIPostPromise(`/contract/resend-contract`, {
      projectId: item.p_id,
      userType: decoded.userType,
    }).then(() => {
      setNotification({
        status: true,
        message: "Contract email sent successfully",
        variant: "success",
      });
    }).finally(() => {
      setChangeOrderLoadingStatus(false);
    });
  };

  const showDeleteConfirmation = (item: any) => {
    const contractId = getContractId(item);
    const hasContractDocument = Boolean(contractId || getContractUrl(item));
    const title = hasContractDocument ? "Delete contract?" : "Delete draft contract?";
    const message = hasContractDocument
      ? "This will remove the generated contract document from the active contract list. Project details will remain available."
      : "This draft contract and its project details will be deleted.";
    const successMessage = hasContractDocument
      ? "Contract deleted successfully"
      : "Draft contract deleted successfully";

    setAlertDetails({
      status: true,
      title,
      message,
      icon: IoTrashOutline,
      button1Text: "Cancel",
      button2Text: "Delete",
      button1Style: "px-4 py-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition",
      button2Style: "px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition",
      onButton1Click: () => console.log("Cancelled"),
      onButton2Click: () => {
        setChangeOrderLoadingStatus(item.p_id)
        const deleteRequest = hasContractDocument
          ? CallAPIPostPromise("/contract/delete-hic-project", {
              pc_id: contractId,
              deleted_by: decoded.userId,
              projectId: item.p_id,
            })
          : CallAPIDeletePromise(`/contract/delete-project/${item.p_id}`);

        deleteRequest.then(()=>{
            setNotification({
              status:true,
              message: successMessage,
              variant:"success"
            })
          setTimeout(() => {
           setNotification({
             status:false,
             message: successMessage,
             variant:"success"
           })
         }, 2000);
          
          fetchData()
        }).finally(()=>{
          setChangeOrderLoadingStatus(false)
        })
      },
    })
  };

  const renderCreateButton = (className = "") => {
    if (!isContractorUser || !canCreateContract) {
      return null;
    }

    if (isSubscriptionSuspended) {
      return (
        <Button
          type="button"
          variant="outline-danger"
          onClick={openPaymentRecovery}
          className={`step-1 ${className}`}
          title={t("Complete the outstanding subscription payment to create a contract")}
        >
          <LockKeyhole size={16} className="me-1" />
          {t("Contract creation paused")}
        </Button>
      );
    }

    return (
      <Button
        onClick={() => {
          if (termsAccepted) {
            setShowContractTypeModal(true);
          } else {
            setPaymentPageShow(true);
          }
        }}
        className={`primary step-1 ${className}`}
      >
        <PlusCircle size={17} className="me-1" />
        {t(termsAccepted ? "Create Contract" : "Subscribe to Create Contracts")}
      </Button>
    );
  };
  
  // Handle page change
  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  
  return (
    <React.Fragment>
      <style>{`
        .contract-type-choice { transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease; }
        .contract-type-choice:hover { border-color: #2f57d6 !important; box-shadow: 0 14px 34px rgba(47, 87, 214, .12); transform: translateY(-1px); }
        .contract-type-modal .modal-content { border: 0; border-radius: 14px; box-shadow: 0 28px 80px rgba(15, 23, 42, .24); overflow: hidden; }
        .contract-type-modal .modal-header { border-bottom: 0; padding: 22px 28px 8px; }
        .contract-type-modal .modal-title { font-size: 24px; font-weight: 800; color: #111827; }
        .contract-type-modal .modal-body { padding: 16px 28px 28px; }
        .contract-type-modal-copy { color: #667085; font-size: 15px; margin-bottom: 18px; }
        .contract-type-modal-card { height: 100%; width: 100%; border: 1px solid #dce5f0; border-radius: 12px; background: #fff; padding: 22px 26px 20px; text-align: center; transition: border-color .18s ease, box-shadow .18s ease, transform .18s ease; }
        .contract-type-modal-card:hover { transform: translateY(-2px); box-shadow: 0 18px 40px rgba(15, 23, 42, .08); }
        .contract-type-modal-card.project { border-color: #c9d8ff; }
        .contract-type-modal-card.project:hover { border-color: #2f57d6; }
        .contract-type-modal-card.subcontract { border-color: #c8e8d2; }
        .contract-type-modal-card.subcontract:hover { border-color: #16a34a; }
        .contract-type-modal-icon { width: 76px; height: 76px; border-radius: 999px; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 16px; }
        .contract-type-modal-icon.project { background: #eef4ff; color: #2457e6; }
        .contract-type-modal-icon.subcontract { background: #e9f8ee; color: #159947; }
        .contract-type-modal-card h5 { color: #111827; font-size: 20px; line-height: 1.25; font-weight: 800; margin-bottom: 14px; }
        .contract-type-modal-divider { height: 1px; background: #e5e7eb; margin-bottom: 14px; }
        .contract-type-modal-card p { color: #667085; font-size: 14px; line-height: 1.4; min-height: 40px; margin-bottom: 18px; }
        .contract-type-modal-list { display: grid; gap: 10px; padding: 0; margin: 0 0 18px; list-style: none; text-align: left; color: #475467; font-size: 13px; }
        .contract-type-modal-list li { display: flex; align-items: center; gap: 9px; }
        .contract-type-modal-list svg { flex: 0 0 auto; }
        .contract-type-modal-button { min-height: 44px; border: 0; border-radius: 8px; color: #fff; font-weight: 800; display: inline-flex; align-items: center; justify-content: center; gap: 10px; }
        .contract-type-modal-button.project { background: linear-gradient(135deg, #2457e6 0%, #1d4ed8 100%); box-shadow: 0 10px 22px rgba(37,87,230,.2); }
        .contract-type-modal-button.subcontract { background: linear-gradient(135deg, #16a34a 0%, #15803d 100%); box-shadow: 0 10px 22px rgba(22,163,74,.2); }
        @media (max-width: 767.98px) {
          .contract-type-modal .modal-header { padding: 22px 22px 8px; }
          .contract-type-modal .modal-body { padding: 18px 22px 24px; }
        }
      `}</style>
  
      {notification && notification.status && (
        <div
          style={{
            position: "absolute",
            top: "5%",
            right: "24px",
            zIndex: 99999,
          }}
        >
          <Alert variant={notification.variant} onClick={handleAlertClick}>
            {notification.message}
          </Alert>
        </div>
      )}
      
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "200px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <>
          <Card className="contract-overview-card mb-4 border-0 shadow-sm">
            <Card.Body>
              <div className="contract-overview-toolbar">
                <div>
                  <p className="contract-overview-copy">
                    {t("Track drafts, live contracts, escrow, and the next action for each contract.")}
                  </p>
                  {!termsAccepted && isContractorUser && (
                    <span className="badge bg-warning-subtle text-warning mt-2">{t("Subscription Required")}</span>
                  )}
                </div>
                <div className="contract-overview-actions">
                  {renderCreateButton("mb-0")}
                  {termsAccepted && isContractorUser && (
                    <Button
                      className="contract-guide-button"
                      style={{
                        backgroundColor:'#F7F7F7',
                        color:'black',
                        border:'1px solid #d0d5dd'
                      }}
                      onClick={()=>{
                        if(setSteps){
                          setIsOpen(false)

                          setIsOpen(true)
                          setSteps([
                            {
                              selector: ".step-1",
                              content: t("Start a new contract draft here."),
                            },
                            {
                              selector: ".step-2",
                              content: t("Use the action buttons to continue drafts or view live contracts."),
                            },
                          ]);
                          
                        }
                      }}
                    >
                      <i className="bx bx-book-open align-center me-1"></i> {t("Guide")}
                    </Button>
                  )}
                </div>
              </div>
              <Row className="g-3 mt-3">
	                <Col md={4}>
	                  <div className="contract-stat-card border rounded p-3 h-100 bg-white">
                    <div className="text-muted small">{t("Draft Contracts")}</div>
                    <div className="fs-4 fw-semibold">{draftContracts}</div>
                    <div className="text-muted small">{t("Can be edited or deleted")}</div>
                  </div>
                </Col>
	                <Col md={4}>
	                  <div className="contract-stat-card border rounded p-3 h-100 bg-white">
                    <div className="text-muted small">{t("Live Contracts")}</div>
                    <div className="fs-4 fw-semibold">{liveContracts}</div>
                    <div className="text-muted small">{t("View-only after activation")}</div>
                  </div>
                </Col>
	                <Col md={4}>
	                  <div className="contract-stat-card border rounded p-3 h-100 bg-white">
                    <div className="text-muted small">{t("Escrow Enabled")}</div>
                    <div className="fs-4 fw-semibold">{escrowContracts}</div>
                    <div className="text-muted small">{t("Contracts using escrow")}</div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

{contracts.length > 0 && <Card className="contract-list-card border-0 shadow-sm">
  <Card.Body>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h5 className="mb-1">{t("Contract List")}</h5>
	        <p className="text-muted mb-0">{t("Review contract status and take the next available action.")}</p>
      </div>
    </div>
    <div className="contract-filter-grid">
      <div className="contract-search-filter">
        <Form.Label className="small text-muted mb-1">{t("Search")}</Form.Label>
        <Form.Control
          type="search"
          value={searchTerm}
          placeholder={t("Search contracts")}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
      </div>
      <div>
        <Form.Label className="small text-muted mb-1">{t("Project Type")}</Form.Label>
        <Form.Select
          value={escrowFilter}
          onChange={(event) => setEscrowFilter(event.target.value)}
        >
          <option value="all">{t("All Projects")}</option>
          <option value="escrow">{t("Escrow Projects Only")}</option>
          <option value="non-escrow">{t("Non-Escrow Projects")}</option>
        </Form.Select>
      </div>
      <div>
        <Form.Label className="small text-muted mb-1">{t("Status")}</Form.Label>
        <Form.Select
          value={statusFilter}
          onChange={(event) => setStatusFilter(event.target.value)}
        >
          <option value="all">{t("All Statuses")}</option>
          <option value="draft">{t("Draft")}</option>
          <option value="live">{t("Live")}</option>
          <option value="signed">{t("Signed")}</option>
          <option value="signature-pending">{t("Signature Pending")}</option>
          <option value="document-ready">{t("Document Ready")}</option>
        </Form.Select>
      </div>
      <div>
        <Form.Label className="small text-muted mb-1">{t("Sort")}</Form.Label>
        <Form.Select
          value={sortFilter}
          onChange={(event) => setSortFilter(event.target.value)}
        >
          <option value="latest">{t("Latest First")}</option>
          <option value="oldest">{t("Oldest First")}</option>
        </Form.Select>
      </div>
      <div className="contract-reset-filter">
        <Button
          variant="outline-secondary"
          className="w-100"
          disabled={filtersAreDefault}
          onClick={() => {
            setSearchTerm("");
            setEscrowFilter(defaultEscrowFilter);
            setStatusFilter("all");
            setSortFilter("latest");
          }}
        >
          {t("Reset")}
        </Button>
      </div>
    </div>
    <div className="table-responsive contract-table-responsive">
    <Table className="table-hover align-middle mb-0 contract-list-table">
      <colgroup>
        <col className="contract-col-project" />
        <col className="contract-col-participants" />
        <col className="contract-col-status" />
        <col className="contract-col-created" />
        <col className="contract-col-actions" />
      </colgroup>
      <thead className="step-2">
        <tr>
          <th>{t("Contract / Project")}</th>
          <th>{t("Participants")}</th>
          <th>{t("Status")}</th>
          <th>{t("Created at")}</th>
          <th className="text-end">{t("Actions")}</th>
        </tr>
      </thead>
      <tbody>
        {currentContracts.length > 0 &&
          currentContracts.map((item: any) => {
            const isDraft = item.p_status !== "LIVE";
            const contractUrl = getContractUrl(item);
            const hasContractDocument = Boolean(getContractId(item) || contractUrl);
            const contractStatus = getContractStatus(item);
            const canUpdateContract = canManageContractRow(item, PERMISSIONS.UPDATE_CONTRACT);
            const canDeleteContract = !isAdminUser && item.p_status !== "LIVE" && canManageContractRow(item, PERMISSIONS.DELETE_CONTRACT);
            const needsSignature = hasContractDocument && (!getContractorSignature(item) || !getHomeownerSignature(item));
            const shouldShowSend = !isAdminUser && hasContractDocument && needsSignature && (canUpdateContract || isContractorUser);
            const shouldShowSign = !isAdminUser && hasContractDocument && canSignContract(item);
            const primaryActionLabel = isAdminUser
              ? "View"
              : isDraft && canUpdateContract
              ? hasContractDocument ? "Review/Edit" : "Continue/Edit"
              : needsSignature ? "View Status" : "View";

            return (
            <React.Fragment key={item.p_id}><tr>
              <td
                className="contract-cell-project"
                onClick={() => openContract(item)}
                style={{ cursor: "pointer" }}
              >
                <div className="fw-semibold">{item.p_name || t("Untitled Contract")}</div>
                <div className="contract-row-meta">
                  <span>#{item.p_id}</span>
                  <span>{hasContractDocument ? t("Document ready") : t("Setup in progress")}</span>
                  {Number(item.p_escrow) === 1 ? <span className="contract-escrow-tag">{t("Escrow")}</span> : null}
                </div>
              </td>
              <td
                className="contract-cell-participants"
                onClick={() => openContract(item)}
                style={{ cursor: "pointer" }}
              >
                <div className="contract-participant"><span>{t("Created by")}</span>{item.createdBy_first_name} {item.createdBy_last_name}</div>
                <div className="contract-participant"><span>{t("Homeowner")}</span><PartnerName id={item.p_home_owner_id}>{item.homeOwner_first_name} {item.homeOwner_last_name}</PartnerName></div>
              </td>
              <td
                className="contract-cell-status"
                onClick={() => openContract(item)}
                style={{ cursor: "pointer" }}
              >
                <span className={contractStatus.className}>
                  {t(contractStatus.label)}
                </span>
              </td>
       
              <td
                className="contract-cell-created"
                onClick={() => openContract(item)}
                style={{ cursor: "pointer" }}
              >
                {convertToUSFormat(item.p_created_at)}
              </td>
              <td className="text-end contract-cell-actions">
                <div className="contract-row-actions">
                  <Button
                    size="sm"
                    variant={isDraft ? "primary" : "outline-primary"}
                    className="d-inline-flex align-items-center"
                    onClick={() =>
                    primaryActionLabel.includes("Status")?viewStatus(item):openContract(item)
                     }
                  >
                    {primaryActionLabel.includes("Edit") ? (
                      <Pencil size={15} className="me-1" />
                    ) : (
                      <Eye size={15} className="me-1" />
                    )}
                    {t(primaryActionLabel)}
                  </Button>
                  {(isAdminUser && item.p_escrow == 1) || canDeleteContract || hasContractDocument || shouldShowSign || shouldShowSend ? (
                    <Dropdown align="end">
                      <Dropdown.Toggle variant="outline-secondary" size="sm" className="contract-more-toggle" aria-label={t("More contract actions")}>
                        <MoreHorizontal size={17} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="contract-actions-menu">
                        {isAdminUser && item.p_escrow == 1 ? (
                          <Dropdown.Item onClick={() => tog_assign_inspector(item.p_id, item.p_name)}>
                            <UserCheck size={15} /> {t(item.p_inspector_id ? "Reassign Inspector" : "Assign Inspector")}
                          </Dropdown.Item>
                        ) : null}
                        {hasContractDocument ? (
                          <Dropdown.Item disabled={!contractUrl} onClick={() => contractUrl && window.open(contractUrl, "_blank")}>
                            <Download size={15} /> {t("Download")}
                          </Dropdown.Item>
                        ) : null}
                        {shouldShowSign ? (
                          <Dropdown.Item onClick={() => openContractTab(item, "sign")}><Pencil size={15} /> {t("Sign Contract")}</Dropdown.Item>
                        ) : null}
                        {shouldShowSend ? (
                          <Dropdown.Item disabled={changeOrderLoadingStatus === item.p_id} onClick={() => sendContract(item)}><Mail size={15} /> {t("Send Email")}</Dropdown.Item>
                        ) : null}
                        {canDeleteContract ? (
                          <>
                            <Dropdown.Divider />
                            <Dropdown.Item className="text-danger" onClick={() => showDeleteConfirmation(item)}><Trash2 size={15} /> {t("Delete")}</Dropdown.Item>
                          </>
                        ) : null}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : null}
                </div>
              </td>
            </tr>
            {item.p_status === "LIVE" && <tr className="contract-inline-review-row"><td colSpan={5} className="p-0"><InlineContractReview projectId={item.p_id} /></td></tr>}
            </React.Fragment>
          )})}
        {currentContracts.length === 0 && (
          <tr>
            <td colSpan={5} className="text-center py-5 contract-empty-state">
              <FileText size={32} className="text-muted mb-2" />
              <div className="fw-semibold">{t("No contracts match your filters")}</div>
              <div className="text-muted small">{t("Try changing the search text or filter options.")}</div>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
    </div>
    <Row className="align-items-center contract-list-pagination">
  <div className="col-sm">
    <div className="text-muted">
      {t("Showing")} <span className="fw-semibold">{currentContracts.length}</span> {t("of")} <span className="fw-semibold">{totalContracts}</span> {t("Results")}
    </div>
  </div>
  <div className="col-sm-auto mt-3 mt-sm-0">
    <div className="pagination-wrap hstack gap-2 justify-content-center">
      <Button
        size="sm"
        variant="outline-secondary"
        className="contract-pagination-button"
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        {t("Previous")}
      </Button>
      <span className="contract-page-count">{t("Page")} {currentPage} {t("of")} {totalPages}</span>
      <Button
        size="sm"
        variant="primary"
        className="contract-pagination-button contract-pagination-next"
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      >
        {t("Next")}
      </Button>
    </div>
  </div>
</Row>


  </Card.Body>
</Card>
}

{contracts.length ===0 &&  <Card className="border-0 shadow-sm">
  <Card.Body className="p-5">
    <div className="text-center mx-auto" style={{ maxWidth: 560 }}>
      <div
        className="mx-auto mb-4 d-flex align-items-center justify-content-center bg-primary-subtle text-primary"
        style={{ width: 72, height: 72, borderRadius: 16 }}
      >
        <FileText size={34} strokeWidth={1.7} />
      </div>
      <h4 className="mb-2">{t("No contracts yet")}</h4>
      <p className="text-muted mb-4">
        {isContractorUser
          ? t("Create your first contract draft, then add milestones, team details, and the contract document.")
          : t("Contracts assigned to you will appear here with their current status and next action.")}
      </p>
      <div className="d-flex justify-content-center gap-2">
        {renderCreateButton("mb-0")}
        {!termsAccepted && isContractorUser && !canCreateContract && (
          <Button
            variant="primary"
            onClick={() => setPaymentPageShow(true)}
          >
            <CreditCard size={17} className="me-1" />
            {t("Subscribe to Create Contracts")}
          </Button>
        )}
      </div>
    </div>
  </Card.Body>
</Card>
}


        </>
      )}

<Modal
  className="contract-inspector-modal"
  size="lg"
  show={modal_assign_inspector}
  onHide={() => {
    tog_assign_inspector(null);
  }}
  backdrop={"static"}
  id="staticBackdrop"
  centered
  data-bs-focus="false"
>
  <Modal.Header
    closeButton
    className="modal-title fw-bold"
    id="staticBackdropLabel"
    style={{ background: "rgb(249, 250, 251)" }}
  >
    {t("Assign Inspector")}
  </Modal.Header>
  <Modal.Body className="p-4" style={{ background: "rgb(249, 250, 251)" }}>
    <div className="mb-4">
      <div className="text-muted small mb-1">{t("Project")}</div>
      <div className="fw-semibold">{assignProjectName || `#${projectIdState}`}</div>
      <div className="text-muted small">{t("Choose an inspector from the list below. All inspectors are loaded automatically and can be searched by name, email, or phone.")}</div>
    </div>

    <div className="mb-4">
      <Form.Label htmlFor="searchInspector">
        {t("Inspector")}
      </Form.Label>
      <Select
        inputId="searchInspector"
        options={newHomeowner}
        isClearable
        isSearchable
        placeholder={t("Search or select inspector")}
        noOptionsMessage={() => t("No inspectors found")}
        onInputChange={(value: any, meta: any) => {
          if (meta.action === "input-change") {
            searchHomeowners(value);
          }
        }}
        onChange={handleSelectedValue}
      />
    </div>

    {showHomeownerForm && inspectorData ? (
      <div className="border rounded bg-white p-3">
        <div className="d-flex align-items-start justify-content-between gap-3">
          <div>
            <div className="text-muted small">{t("Selected Inspector")}</div>
            <div className="fw-semibold">
              {[inspectorData.user_first_name, inspectorData.user_last_name].filter(Boolean).join(" ") || t("Unnamed Inspector")}
            </div>
            <div className="text-muted small">{inspectorData.user_email || "-"}</div>
          </div>
          <span className={inspectorData.is_active === 0 ? "badge bg-warning-subtle text-warning" : "badge bg-success-subtle text-success"}>
            {t(inspectorData.is_active === 0 ? "Inactive" : "Active")}
          </span>
        </div>
        <Row className="g-3 mt-1">
          <Col md={6}>
            <div className="text-muted small">{t("Phone")}</div>
            <div>{inspectorData.user_phone || "-"}</div>
          </Col>
          <Col md={6}>
            <div className="text-muted small">{t("Inspector ID")}</div>
            <div>#{inspectorData.id}</div>
          </Col>
        </Row>
      </div>
    ) : (
      <div className="border rounded bg-white p-4 text-center text-muted">
        <UserCheck size={28} className="mb-2" />
        <div>{t("Select an inspector to preview details before assigning.")}</div>
      </div>
    )}
  
  </Modal.Body>
  <Modal.Footer style={{ background: "rgb(249, 250, 251)" }}>
    <Button
      variant="light"
      onClick={() => tog_assign_inspector(null)}
      disabled={assignInspectorLoading}
    >
      {t("Cancel")}
    </Button>
    <Button
      variant="primary"
      className="d-inline-flex align-items-center"
      onClick={handleAssignContract}
      disabled={!homeOwnerId || assignInspectorLoading}
    >
      {assignInspectorLoading ? (
        <Spinner style={{ height: 16, width: 16 }} animation="border" role="status" className="me-2" />
      ) : (
        <UserCheck size={16} className="me-2" />
      )}
      {t(assignInspectorLoading ? "Assigning..." : "Assign Inspector")}
    </Button>
  </Modal.Footer>
</Modal>

<Modal className="contract-create-type-modal" show={showContractTypeModal} onHide={() => setShowContractTypeModal(false)} centered size="xl" dialogClassName="contract-type-modal">
  <Modal.Header closeButton>
    <Modal.Title>{t("Choose Contract Type")}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p className="contract-type-modal-copy">
      {t("Select the type of contract you want to create. We will open the correct flow based on your choice.")}
    </p>
    <Row className="g-4">
      <Col md={6}>
        <button
          type="button"
          className="contract-type-modal-card project"
          onClick={() => {
            setShowContractTypeModal(false);
            navigate("/create-contract?type=project");
          }}
        >
          <span className="contract-type-modal-icon project">
            <Home size={40} strokeWidth={1.8} />
          </span>
          <h5>{t("Project Contract with Homeowner")}</h5>
          <div className="contract-type-modal-divider" />
          <p>
            {t("Create a project, add homeowner, milestones, and subcontractors.")}
          </p>
          <ul className="contract-type-modal-list">
            <li><CheckCircle2 size={16} className="text-primary" />{t("Create project and add details")}</li>
            <li><CheckCircle2 size={16} className="text-primary" />{t("Add homeowner and milestones")}</li>
            <li><CheckCircle2 size={16} className="text-primary" />{t("Add subcontractors and create contracts")}</li>
          </ul>
          <span className="contract-type-modal-button project w-100">
            {t("Start Project Contract")} <ArrowRight size={17} />
          </span>
        </button>
      </Col>
      <Col md={6}>
        <button
          type="button"
          className="contract-type-modal-card subcontract"
          onClick={() => {
            setShowContractTypeModal(false);
            navigate("/create-contract?type=subcontract");
          }}
        >
          <span className="contract-type-modal-icon subcontract">
            <Handshake size={40} strokeWidth={1.8} />
          </span>
          <h5>{t("Subcontractor Agreement")}</h5>
          <div className="contract-type-modal-divider" />
          <p>
            {t("Create a contract between a contractor/GC and subcontractor.")}
          </p>
          <ul className="contract-type-modal-list">
            <li><CheckCircle2 size={16} className="text-success" />{t("Contractor and subcontractor details")}</li>
            <li><CheckCircle2 size={16} className="text-success" />{t("Scope of work and milestones")}</li>
            <li><CheckCircle2 size={16} className="text-success" />{t("Review and send for signature")}</li>
          </ul>
          <span className="contract-type-modal-button subcontract w-100">
            {t("Create Subcontractor Agreement")} <ArrowRight size={17} />
          </span>
        </button>
      </Col>
    </Row>
  </Modal.Body>
</Modal>
  
<AIContractChatModal show={aiModalStatus}  handleClose={()=>{
  setAIModalStatus(false)
}}/>
  <CreateChangeOrderModal modal_change_order={changeOrderModalStatus}  tog_change_order={()=>{
          setChangeOrderModalStatus(s=>!s)
        }}/>
      <TwoButtonAlert setDetails={setAlertDetails}  details={alertDetails}/>
      {selectedContract && (
        <ContractDetailDialog
          contractID={selectedContract}
          selectedActionType={selectedActionType}
          signerType={selectedSignerType}
          onClose={() => setSelectedContract(null)}
          onSign={()=>{
            setSelectedContract(null);
            toast.success("Contract Signed")
            fetchData()
          }}
        />
      )}
    </React.Fragment>
  );
};

export default ContractList;
